import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateTicketRMADetails } from '../../../../actions/tickets';
import { findAllRepairCenters, getSpareAssetWithAssetId, getWareHouseDropdown } from '../../../../actions/inventory';
import { actualValueForDropdown, debounce, validateStringValue } from '../../../../utils/common';
import { getCourierVendors } from '../../../../actions/users';
import moment from 'moment';
import { UpdateRMAForm } from './UpdateRmaForm';
import { projectCss, textCss } from '../../../../common/Css';
import { getServiceRequestById, updateRma } from '../../../../actions/service_request';
import RenderMilestones from '../../components/RenderMileStones';
import { convertIntoPaisa } from '../../../../utils/utils';
import { isIndividualMilestoneStatusInRange, MilestoneSubStatus } from '../../TicketController';

const formName = 'update_rma_details';

export const fullDevice = { key: 1, value: 'full', label: 'Full Device' };
export const partDevice = { key: 2, value: 'partial', label: 'Device Part' };
export const componentConsumedFromSystem = { key: 3, value: 'components', label: 'Component Consumed from system' };
export const noDeviceConsumed = { key: 4, value: 'none', label: 'No Device Consumed' };

export const rmaRequestTypeOptions = [fullDevice, partDevice, componentConsumedFromSystem, noDeviceConsumed];

export const handHelding = { value: 'HAND_HELDING', name: 'cl_rma_response', label: 'Hand Helding' };
export const docketNumber = { value: 'DOCKET_NUMBER', name: 'cl_rma_response', label: 'Docket Number' };
export const requestPickup = { value: 'REQUEST_PICKUP', name: 'cl_rma_response', label: 'Request Pickup' };

export const radioOptions = [handHelding, docketNumber, requestPickup];

export default function UpdateRmaDetails({ id, heading = 'Update RMA Details', source }) {
    const dispatch = useDispatch();
    const [selectedMilestone, setSelectedMilestone] = useState();


    const serviceRequestData = useSelector(state => state.serviceRequest.serviceRequestData);
    const serviceRequestByIdLoading = useSelector(state => state.loading.serviceRequestByIdLoading);

    const serviceRequest = useMemo(() => {
        return serviceRequestData?.[id] || {};
    }, [serviceRequestData, id]);

    const currentMilestone = useMemo(() => {
        let m = {};
        if (selectedMilestone && serviceRequest.milestones) {
            m = serviceRequest.milestones.find(milestone => milestone.id === selectedMilestone);
        }
        return m;
    }, [serviceRequest, selectedMilestone]);

    useEffect(() => {
        if (id) {
            dispatch(getServiceRequestById({ ticketId: id }));
        }
    }, [id, dispatch]);

    const defaultValues = {
        eta: new Date(),
        consumption_type: fullDevice,
    };

    const submit = (formValues) => {
        const payload = {
            asset_number: formValues.fetched_asset_number,
            serial_number: formValues.fetched_serial_number,
            ticket_id: id,
            milestone_id: selectedMilestone,
            consumption_type: actualValueForDropdown(formValues.consumption_type),
            courier_vendor_id: actualValueForDropdown(formValues.courier_vendor_id),
            docket_number: formValues.docket_number,
            dispatch_location_id: actualValueForDropdown(formValues.dispatch_location_id),
            received_location_id: actualValueForDropdown(formValues.received_location_id),
            eta: formValues.eta,
            courier_cost: formValues.courier_cost ? convertIntoPaisa(parseFloat(formValues.courier_cost)) : undefined,
            release_vendor: Boolean(formValues.release_vendor),
            part_name: formValues.part_name ? formValues.part_name : undefined,
        };
        dispatch(updateRma({ formName, payload, source }));
    };

    const memoizedMilestones = useMemo(() => {
        return serviceRequest?.milestones ? serviceRequest?.milestones?.filter(milestone => {
            return milestone.type === 'RMA' && isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED);
        }).map((elem) => {
            return {
                ...elem,
                type: `${elem.type} ${elem?.rma?.consumption_type ? `${elem?.rma?.consumption_type ? `: Device (${elem?.rma?.consumption_type})` : ''}` : ': pending'}`
            }
        }) : [];
    }, [serviceRequest?.milestones]);

    return (
        <>
            <div className={`subContainer title-4 p-5`}>
                <div className={`titleContainer flex items-center`}>
                    <h1 className='text-scogo21 text-font16 font-medium font-rubik '>{heading} : <span className='text-scogobgsky text-font16'>{serviceRequest?.ticket_number}</span></h1>
                    {serviceRequest.milestones && <div className='flex gap-2 pl-4'>
                        <RenderMilestones
                            milestones={memoizedMilestones}
                            selectedMilestones={selectedMilestone}
                            setSelectedMilestones={setSelectedMilestone}
                            agents={serviceRequest?.agents}
                            showAgentsOnHover
                        />
                    </div>}
                </div>
                <div className='flex-auto'>
                    <div className='flex-auto '>
                        <div className='tab-content tab-space bg-white shadow-xl rounded-lg	'>
                            <div className={`${projectCss?.scmAddProjectForm} lg:pb-0 md:pb-168 pb-230 overflow-auto mb-24 md:mb-24`}>
                                <UpdateRMAForm
                                    defaultValues={defaultValues}
                                    submit={submit}
                                    ticketId={id}
                                    formName={formName}
                                    serviceRequest={serviceRequest}
                                    currentMilestone={currentMilestone}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
